<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6 support-ticket-container">

  <!-- Header -->
  <div class="mb-8">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div>
        <h1 class="text-3xl font-bold text-gray-900 mb-2">Support Tickets</h1>
        <p class="text-gray-600">Track, prioritize, and resolve internal support requests</p>
      </div>
      <div class="flex flex-wrap gap-3">
        <ng-container *ngIf="viewMode === 'list'">
          <button
            type="button"
            (click)="showCreateForm()"
            class="inline-flex items-center px-6 py-2.5 border border-transparent text-sm font-medium rounded-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-lg"
          >
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            Create New Ticket
          </button>
        </ng-container>
        <ng-container *ngIf="viewMode === 'form'">
          <button
            type="button"
            (click)="showList()"
            class="inline-flex items-center px-5 py-2.5 border border-gray-300 text-sm font-medium rounded-xl text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-sm"
          >
            <mat-icon class="!text-lg mr-1">list</mat-icon>
            View All Tickets
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Stats -->
  <div *ngIf="viewMode === 'list' && stats" class="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-4 mb-8">
    <div class="bg-white rounded-2xl shadow-sm border border-gray-200 p-4 flex items-center gap-3">
      <div class="w-12 h-12 rounded-xl bg-blue-100 text-blue-600 flex items-center justify-center"><mat-icon>confirmation_number</mat-icon></div>
      <div>
        <p class="text-xs font-medium uppercase tracking-wider text-gray-500">Total Tickets</p>
        <p class="text-2xl font-bold text-gray-900">{{ stats.total_tickets }}</p>
      </div>
    </div>
    <div class="bg-white rounded-2xl shadow-sm border border-gray-200 p-4 flex items-center gap-3">
      <div class="w-12 h-12 rounded-xl bg-cyan-100 text-cyan-700 flex items-center justify-center"><mat-icon>lock_open</mat-icon></div>
      <div>
        <p class="text-xs font-medium uppercase tracking-wider text-gray-500">Open</p>
        <p class="text-2xl font-bold text-gray-900">{{ stats.open_tickets }}</p>
      </div>
    </div>
    <div class="bg-white rounded-2xl shadow-sm border border-gray-200 p-4 flex items-center gap-3">
      <div class="w-12 h-12 rounded-xl bg-amber-100 text-amber-700 flex items-center justify-center"><mat-icon>autorenew</mat-icon></div>
      <div>
        <p class="text-xs font-medium uppercase tracking-wider text-gray-500">In Progress</p>
        <p class="text-2xl font-bold text-gray-900">{{ stats.in_progress_tickets }}</p>
      </div>
    </div>
    <div class="bg-white rounded-2xl shadow-sm border border-gray-200 p-4 flex items-center gap-3">
      <div class="w-12 h-12 rounded-xl bg-green-100 text-green-700 flex items-center justify-center"><mat-icon>check_circle</mat-icon></div>
      <div>
        <p class="text-xs font-medium uppercase tracking-wider text-gray-500">Resolved</p>
        <p class="text-2xl font-bold text-gray-900">{{ stats.resolved_tickets }}</p>
      </div>
    </div>
    <div class="bg-white rounded-2xl shadow-sm border border-gray-200 p-4 flex items-center gap-3">
      <div class="w-12 h-12 rounded-xl bg-red-100 text-red-700 flex items-center justify-center"><mat-icon>error</mat-icon></div>
      <div>
        <p class="text-xs font-medium uppercase tracking-wider text-gray-500">Critical</p>
        <p class="text-2xl font-bold text-gray-900">{{ stats.critical_tickets }}</p>
      </div>
    </div>
    <div class="bg-white rounded-2xl shadow-sm border border-gray-200 p-4 flex items-center gap-3">
      <div class="w-12 h-12 rounded-xl bg-purple-100 text-purple-700 flex items-center justify-center"><mat-icon>schedule</mat-icon></div>
      <div>
        <p class="text-xs font-medium uppercase tracking-wider text-gray-500">Last 7 Days</p>
        <p class="text-2xl font-bold text-gray-900">{{ stats.tickets_last_7_days }}</p>
      </div>
    </div>
  </div>

  <!-- List view -->
  <div *ngIf="viewMode === 'list'" class="list-container">

    <!-- Filters -->
    <div class="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 mb-8">
      <div class="flex flex-col gap-4">
        <div class="flex flex-col xl:flex-row xl:items-end gap-4">
          <div class="flex-1 min-w-0">
            <label class="block text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1">Search</label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <input
                type="text"
                placeholder="Search by ticket number, name, or description"
                (input)="onSearchChange($event)"
                class="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-xl leading-5 bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200"
              />
            </div>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 xl:flex xl:flex-nowrap xl:gap-3">
            <div class="xl:w-44">
              <label class="block text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1">Category</label>
              <select
                [(ngModel)]="filters.category"
                (change)="applyFilters()"
                class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
              >
                <option [ngValue]="undefined">All Categories</option>
                <option *ngFor="let cat of categories" [ngValue]="cat.name">{{ cat.name }}</option>
              </select>
            </div>
            <div class="xl:w-40">
              <label class="block text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1">Priority</label>
              <select
                [(ngModel)]="filters.priority"
                (change)="applyFilters()"
                class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
              >
                <option [ngValue]="undefined">All Priorities</option>
                <option *ngFor="let priority of priorityOptions" [ngValue]="priority">{{ getPriorityText(priority) }}</option>
              </select>
            </div>
            <div class="xl:w-40">
              <label class="block text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1">Status</label>
              <select
                [(ngModel)]="filters.status"
                (change)="applyFilters()"
                class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
              >
                <option [ngValue]="undefined">All Statuses</option>
                <option *ngFor="let status of statusOptions" [ngValue]="status">{{ getStatusText(status) }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="flex justify-end">
          <button
            type="button"
            (click)="clearFilters()"
            class="inline-flex items-center px-4 py-2.5 border border-gray-300 text-sm font-medium rounded-xl text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-sm"
          >
            <mat-icon class="!text-lg mr-1">filter_alt_off</mat-icon>
            Clear Filters
          </button>
        </div>
      </div>
    </div>

    <!-- Tickets table -->
    <div class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden table-card">
      <div class="px-6 py-4 border-b border-gray-200 bg-gray-50">
        <h2 class="text-lg font-semibold text-gray-900">Tickets overview</h2>
        <p class="text-sm text-gray-600 mt-1">All open and historical support tickets</p>
      </div>

      <div class="table-container overflow-x-auto">
        <table mat-table [dataSource]="filteredTickets" class="tickets-table w-full">

          <ng-container matColumnDef="ticket_number">
            <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Ticket #</th>
            <td mat-cell *matCellDef="let ticket" class="px-6 py-4 whitespace-nowrap">
              <span class="ticket-number">{{ ticket.ticket_number }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Name</th>
            <td mat-cell *matCellDef="let ticket" class="px-6 py-4">
              <div class="user-info">
                <span class="user-name">{{ ticket.name }}</span>
                <span class="user-detail" *ngIf="ticket.job_title">{{ ticket.job_title }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Category</th>
            <td mat-cell *matCellDef="let ticket" class="px-6 py-4 whitespace-nowrap">
              <span class="badge badge-category">{{ ticket.ticket_category }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="department">
            <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Department</th>
            <td mat-cell *matCellDef="let ticket" class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{{ ticket.department }}</td>
          </ng-container>

          <ng-container matColumnDef="priority">
            <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Priority</th>
            <td mat-cell *matCellDef="let ticket" class="px-6 py-4 whitespace-nowrap">
              <span class="badge badge-priority" [style.background-color]="getPriorityColor(ticket.priority)">{{ getPriorityText(ticket.priority) }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Status</th>
            <td mat-cell *matCellDef="let ticket" class="px-6 py-4 whitespace-nowrap">
              <mat-form-field appearance="outline" class="status-select">
                <mat-select
                  [(ngModel)]="ticket.status"
                  (selectionChange)="updateTicketStatus(ticket, $event.value)"
                  [style.color]="getStatusColor(ticket.status)"
                >
                  <mat-option *ngFor="let status of statusOptions" [value]="status">{{ getStatusText(status) }}</mat-option>
                </mat-select>
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Created</th>
            <td mat-cell *matCellDef="let ticket" class="px-6 py-4 whitespace-nowrap">
              <div class="date-info">
                <span class="date-full">{{ formatDate(ticket.created_at) }}</span>
                <span class="date-relative">{{ getTimeAgo(ticket.created_at) }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Actions</th>
            <td mat-cell *matCellDef="let ticket" class="px-6 py-4 whitespace-nowrap">
              <div class="action-buttons">
                <button mat-icon-button color="primary" (click)="viewTicket(ticket)" matTooltip="View Details">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button mat-icon-button color="accent" (click)="editTicket(ticket)" matTooltip="Edit Ticket">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="deleteTicket(ticket)" matTooltip="Delete Ticket">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-50"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="ticket-row hover:bg-gray-50 transition-colors duration-150"></tr>
        </table>
      </div>

      <!-- Empty -->
      <div *ngIf="filteredTickets.length === 0 && !loading" class="text-center py-12 px-4">
        <div class="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
          <mat-icon class="!text-5xl text-gray-400">inbox</mat-icon>
        </div>
        <h3 class="text-lg font-medium text-gray-900 mb-2">No tickets found</h3>
        <p class="text-gray-500 mb-6">Open a new ticket to get started.</p>
        <button
          type="button"
          (click)="showCreateForm()"
          class="inline-flex items-center px-6 py-3 border border-transparent text-sm font-medium rounded-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200"
        >
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          Create Your First Ticket
        </button>
      </div>

      <!-- Loading -->
      <div *ngIf="loading" class="flex flex-col items-center justify-center py-16">
        <mat-spinner diameter="48"></mat-spinner>
        <p class="text-gray-600 mt-4">Loading tickets...</p>
      </div>

      <!-- Pagination -->
      <div *ngIf="filteredTickets.length > 0" class="px-6 py-4 border-t border-gray-200 bg-gray-50">
        <div class="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div class="text-sm text-gray-600">
            Showing {{ (currentPage - 1) * pageSize + 1 }} to
            {{ currentPage * pageSize > totalRecords ? totalRecords : currentPage * pageSize }}
            of {{ totalRecords }} tickets
          </div>
          <mat-paginator
            [length]="totalRecords"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            [pageIndex]="currentPage - 1"
            (page)="onPageChange($event)"
            class="bg-transparent"
          ></mat-paginator>
        </div>
      </div>
    </div>
  </div>

  <!-- Form View -->
  <div class="form-container" *ngIf="viewMode === 'form'">
    <div class="loading-overlay" *ngIf="loading">
      <mat-spinner diameter="50"></mat-spinner>
      <p>{{ mode === 'add' ? 'Creating ticket...' : 'Updating ticket...' }}</p>
    </div>

    <mat-card class="ticket-form-card">
      <mat-card-title>
        <mat-icon class="title-icon">{{ mode === 'add' ? 'add' : mode === 'edit' ? 'edit' : 'visibility' }}</mat-icon>
        {{ mode === 'add' ? 'Create New Support Ticket' : mode === 'edit' ? 'Edit Support Ticket' : 'View Support Ticket' }}
      </mat-card-title>

      <form [formGroup]="ticketForm" (ngSubmit)="onSubmit()">
        <!-- Basic Information -->
        <mat-card-subtitle>Basic Information</mat-card-subtitle>
        <div class="form-row">
          <div class="half-width" *ngIf="mode !== 'add'">
            <mat-label>Ticket Number</mat-label>
             <mat-form-field appearance="outline">
              
              <input matInput formControlName="ticket_number" readonly>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Ticket Category *</mat-label>
            <mat-form-field appearance="outline">
              
              <mat-select formControlName="ticket_category">
                <mat-option *ngFor="let cat of categories" [value]="cat.name">{{ cat.name }}</mat-option>
              </mat-select>
              <mat-error *ngIf="ticketForm.get('ticket_category')?.hasError('required')">Category is required</mat-error>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Name *</mat-label>
            <mat-form-field appearance="outline">
              
              <input matInput formControlName="name" placeholder="Enter your name">
              <mat-error *ngIf="ticketForm.get('name')?.hasError('required')">Name is required</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-row">
          <div class="half-width">
            <mat-label>Job Title</mat-label>
            <mat-form-field appearance="outline">
              
              <input matInput formControlName="job_title" placeholder="Enter job title">
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Phone</mat-label>
            <mat-form-field appearance="outline">
              
              <input matInput formControlName="phone" placeholder="Enter phone number">
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Manager</mat-label>
            <mat-form-field appearance="outline">
              
              <input matInput formControlName="manager" placeholder="Enter manager name">
            </mat-form-field>
          </div>
        </div>

        <div class="form-row">
          <div class="half-width">
            <mat-label>Date & Time *</mat-label>
            <mat-form-field appearance="outline">
              
              <input matInput type="datetime-local" formControlName="date_time">
              <mat-error *ngIf="ticketForm.get('date_time')?.hasError('required')">Date & time is required</mat-error>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>ID Number *</mat-label>
            <mat-form-field appearance="outline">
              
              <input matInput formControlName="id_number" placeholder="Enter ID number">
              <mat-error *ngIf="ticketForm.get('id_number')?.hasError('required')">ID number is required</mat-error>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Department *</mat-label>
            <mat-form-field appearance="outline">
              
              <input matInput formControlName="department" placeholder="Enter department">
              <mat-error *ngIf="ticketForm.get('department')?.hasError('required')">Department is required</mat-error>
            </mat-form-field>
          </div>
        </div>

        <!-- Problem Details -->
        <mat-divider class="my-divider"></mat-divider>
        <mat-card-subtitle>Problem Details</mat-card-subtitle>

        <div class="form-row">
          <div class="half-width" *ngIf="showAdminFields()">
            <mat-label>Technician *</mat-label>
             <mat-form-field appearance="outline">
              
              <input matInput formControlName="technician" placeholder="Enter technician name">
              <mat-error *ngIf="ticketForm.get('technician')?.hasError('required')">Technician is required</mat-error>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Priority *</mat-label>
            <mat-form-field appearance="outline">
              <mat-select formControlName="priority">
                <mat-option *ngFor="let p of priorityOptions" [value]="p">{{ getPriorityText(p) }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="half-width" *ngIf="showAdminFields()">
            <mat-label>Status</mat-label><mat-form-field appearance="outline">
              
              <mat-select formControlName="status">
                <mat-option *ngFor="let s of statusOptions" [value]="s">{{ getStatusText(s) }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="full-width">
          <mat-label>Problem Description *</mat-label>
           <mat-form-field appearance="outline">
            
            <textarea matInput formControlName="problem_description" rows="4" 
                      placeholder="Describe the problem in detail"></textarea>
            <mat-error *ngIf="ticketForm.get('problem_description')?.hasError('required')">Problem description is required</mat-error>
          </mat-form-field>
        </div>

        <!-- Assignment & Response (Admin & Support Person Only) -->
        <div *ngIf="showAdminFields()">
          <mat-divider class="my-divider"></mat-divider>
          <mat-card-subtitle>Assignment & Response</mat-card-subtitle>

          <div class="form-row" *ngIf="showAssignmentFields()">
            <div class="half-width">
              <mat-label>Assigned To (Staff Member)</mat-label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="assigned_user_id" placeholder="Select staff member" [disabled]="isLoadingStaff">
                  <mat-option *ngIf="isLoadingStaff" disabled>
                    <span class="flex items-center">
                      <mat-icon class="animate-spin mr-2">refresh</mat-icon>
                      Loading staff...
                    </span>
                  </mat-option>
                  <mat-option [value]="null">Unassigned</mat-option>
                  <mat-option *ngFor="let staff of staffList" [value]="staff.id">
                    {{ staff.full_name || (staff.first_name + ' ' + staff.last_name) }}
                    <span *ngIf="staff.email_id"> ({{ staff.email_id }})</span>
                  </mat-option>
                  <mat-option *ngIf="!isLoadingStaff && staffList.length === 0" disabled>
                    No staff members found
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>Assigned To (Name)</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="assigned_to" placeholder="Assign to staff member">
              </mat-form-field>
            </div>
          </div>

          <div class="form-row">
            <div class="half-width">
              <mat-label>Response Date</mat-label>
              <mat-form-field appearance="outline">
                <input matInput type="date" formControlName="response_date">
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>Response Time</mat-label>
              <mat-form-field appearance="outline">
                <input matInput type="time" formControlName="response_time">
              </mat-form-field>
            </div>
          </div>

          <div class="form-row">
            <div class="half-width">
              <mat-label>Total Hours Worked</mat-label>
              <mat-form-field appearance="outline">
                <input matInput type="number" formControlName="total_hours_worked" min="0" step="0.5">
              </mat-form-field>
            </div>
          </div>

          <!-- Actions Taken -->
          <mat-divider class="my-divider"></mat-divider>
          <mat-card-subtitle>Actions Taken</mat-card-subtitle>

          <div class="full-width">
            <mat-label>Initial Action</mat-label>
            <mat-form-field appearance="outline">
              <textarea matInput formControlName="initial_action" rows="3" 
                        placeholder="Describe initial action taken"></textarea>
            </mat-form-field>
          </div>

          <div class="full-width">
            <mat-label>Follow-up Action</mat-label>
            <mat-form-field appearance="outline">
              <textarea matInput formControlName="follow_up_action" rows="3" 
                        placeholder="Describe follow-up action"></textarea>
            </mat-form-field>
          </div>

          <!-- Importance Level -->
          <mat-divider class="my-divider"></mat-divider>
          <mat-card-subtitle>Importance Level</mat-card-subtitle>

          <div class="importance-section">
            <mat-checkbox formControlName="importance_mission_critical" class="importance-checkbox">
              Mission Critical
            </mat-checkbox>
            <mat-checkbox formControlName="importance_slowing_user_down" class="importance-checkbox">
              Slowing User Down
            </mat-checkbox>
            <mat-checkbox formControlName="importance_to_be_scheduled" class="importance-checkbox">
              To Be Scheduled
            </mat-checkbox>
          </div>

          <!-- Conclusion -->
          <mat-divider class="my-divider"></mat-divider>
          <mat-card-subtitle>Conclusion</mat-card-subtitle>

          <div class="conclusion-section">
            <mat-checkbox formControlName="conclusion_resolved" class="conclusion-checkbox">
              Resolved
            </mat-checkbox>
            <mat-checkbox formControlName="conclusion_pending" class="conclusion-checkbox">
              Pending
            </mat-checkbox>
            <mat-checkbox formControlName="conclusion_unresolved" class="conclusion-checkbox">
              Unresolved
            </mat-checkbox>
          </div>

          <div class="full-width">
            <mat-form-field appearance="outline">
              <mat-label>Final Notes</mat-label>
              <textarea matInput formControlName="final_notes" rows="4" 
                        placeholder="Add any final notes or comments"></textarea>
            </mat-form-field>
          </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
          <button mat-raised-button color="primary" type="submit" 
                  [disabled]="ticketForm.invalid || loading" *ngIf="mode !== 'view'">
            <mat-icon>{{ mode === 'add' ? 'add' : 'save' }}</mat-icon>
            {{ mode === 'add' ? 'Create Ticket' : 'Update Ticket' }}
          </button>
          <button mat-button type="button" (click)="onCancel()">
            <mat-icon>{{ mode === 'view' ? 'arrow_back' : 'cancel' }}</mat-icon>
            {{ mode === 'view' ? 'Back to List' : 'Cancel' }}
          </button>
        </div>
      </form>
    </mat-card>
  </div>
</div>
